import { AxiosResponse } from 'axios'
import { generalServiceAPI } from '@/store/api-instance'
import { shipmentPlaces, orderTransportTypes } from '@/utils/mockAPIresponse'
import { IOrder, IOrderListRequest, IUploadBulkOrder, IOrderTracking, IOrderTrackingRequest, IDeliveryPlanRequest, IDeliveryPlan } from '../interfaces/orders.interface'

async function getOrdersAPI (dto: IOrderListRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<IOrder>('orders', { params: dto })
  return response.data
}

async function getShipmentPlacesAPI () {
  return await JSON.parse(shipmentPlaces)
}

async function getOrderTransportTypesAPI () {
  return await JSON.parse(orderTransportTypes)
}

async function uploadBulkOrderAPI (dto: IUploadBulkOrder) {
  const response: AxiosResponse = await generalServiceAPI.post<IOrder>(`orders/BulkUploadOrdersAsync?store=${dto.store}`, dto.fileAttachment, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

async function getOrderTrackingAPI (dto: IOrderTrackingRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<IOrderTracking>(`orders/GetTracking/${dto?.orderId}`)
  return response.data
}

async function getDeliveryPlanAPI (dto: IDeliveryPlanRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<IDeliveryPlan>('orders/GetDeliveryPlan', { params: dto })
  return response.data
}

async function getDevlieryPlanExcel (dto: IDeliveryPlanRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<Blob>('orders/GetDeliveryPlanExportExcel', { params: dto, responseType: 'blob' })
  return response
}

async function getProductBrandsAPI (dto: IDeliveryPlanRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<IDeliveryPlan>('orders/GetProductBrand', { params: dto })
  return response.data
}

async function getPackFormatAPI () {
  const response: AxiosResponse = await generalServiceAPI.get<IDeliveryPlan>('orders/GetPackFormat')
  return response.data
}

async function getSKUsAPI (dto: IDeliveryPlanRequest) {
  const response: AxiosResponse = await generalServiceAPI.get<IDeliveryPlan>('orders/GetSkuName', { params: dto })
  return response.data
}

export {
  getOrdersAPI,
  getShipmentPlacesAPI,
  getOrderTransportTypesAPI,
  uploadBulkOrderAPI,
  getOrderTrackingAPI,
  getDeliveryPlanAPI,
  getDevlieryPlanExcel,
  getProductBrandsAPI,
  getPackFormatAPI,
  getSKUsAPI
}
